// profileReducer.js
import { createSlice } from '@reduxjs/toolkit';
import {
  fetchUserProfile,
  updateUserProfile,
  changeUserPassword,
  logoutUser,
} from './profileActions';

const initialState = {
  user: null, // Changed from 'data' to 'user' to match component usage
  loading: false,
  saving: false,
  error: null,
  passwordChanging: false,
  passwordChangedAt: null,
};

const profileSlice = createSlice({
  name: 'profile', // Changed to match component selector
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearProfile: (state) => {
      state.user = null;
      state.loading = false;
      state.saving = false;
      state.error = null;
      state.passwordChanging = false;
      state.passwordChangedAt = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch
      .addCase(fetchUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload || null;
      })
      .addCase(fetchUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to load profile';
      })

      // Update
      .addCase(updateUserProfile.pending, (state) => {
        state.saving = true;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.saving = false;
        state.user = action.payload || state.user; // keep existing if backend returned nothing
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.saving = false;
        state.error = action.payload || action.error?.message || 'Failed to update profile';
      })

      // Change password
      .addCase(changeUserPassword.pending, (state) => {
        state.passwordChanging = true;
        state.error = null;
      })
      .addCase(changeUserPassword.fulfilled, (state) => {
        state.passwordChanging = false;
        state.passwordChangedAt = Date.now();
      })
      .addCase(changeUserPassword.rejected, (state, action) => {
        state.passwordChanging = false;
        state.error = action.payload || action.error?.message || 'Failed to change password';
      })

      // Logout
      .addCase(logoutUser.fulfilled, (state) => {
        // clear profile state completely on logout
        state.user = null;
        state.loading = false;
        state.saving = false;
        state.error = null;
        state.passwordChanging = false;
        state.passwordChangedAt = null;
      });
  },
});

export const { clearError, clearProfile } = profileSlice.actions;
export default profileSlice.reducer;